import { Component, Input } from '@angular/core';
import { SheetService } from './sheet.service';
import { MaterializeAction } from 'angular2-materialize';
import { ImportColumnCheckboxModel } from '../models/ImportColumnCheckboxModel';

declare var Materialize: any;
declare var $: any;

@Component({
    selector: 'sheet-export-import',
    templateUrl: 'sheet-export-import.component.html'
})
export class SheetComponent {

    private allColumnsSelected: boolean;
    // The sheet name given to the sheet to be exported.
    private currentSheetName: string;
    // Can be used when running multiple of the same reports to avoid prompts for each
    private rememberColumns: boolean;
    // Forward back to caller for selection
    // This is used for multi-reports and allowing remember me
    private replyToCaller: boolean;
    private waitingForSelection: boolean;
    private callerName: string;
    // The data to be exported into the sheet.
    public data: any;
    // Array of column names to allow user to remove non required columns.
    private coloumnCheckBoxes: ImportColumnCheckboxModel[];

    constructor(private _sheetService: SheetService) {
        this.currentSheetName = '';
        this.coloumnCheckBoxes = [];
        this.allColumnsSelected = true;
        this.rememberColumns = false;
        this.replyToCaller = false;
        this.waitingForSelection = false;
        // Subscribe to sheet service so that a prompt can be displayed
        // when it broadcasts the event.
        this._sheetService.promptColumnSelection
            .subscribe((data) => {
                if (data instanceof Array) {
                    this.prompt(data[0], data[1]);
                    this.replyToCaller = data[2];
                    this.callerName = data[3];
                    this.waitingForSelection = true;
                }
        });
    }

    // Toggle all columns
    private toggleColumns(): void {
        if (this.allColumnsSelected) {
            this.allColumnsSelected = !this.allColumnsSelected;
            this.coloumnCheckBoxes.forEach(cbx => cbx.includeColumn = false);
        } else {
            this.allColumnsSelected = !this.allColumnsSelected;
            this.coloumnCheckBoxes.forEach(cbx => cbx.includeColumn = true);
        }
    }

    // Add sheet data and prompt user for sheet name and select columns
    public prompt(data: any, sheetName = ''): void {
        this.currentSheetName = sheetName;
        this.data = data;
        this.populateColumnNames();
        this.open();
    }

    // Open this components modal
    private open(): void {
        $('#sheet-export-import-modal').modal('open');
    }

    // Returns a bool value if a sheet name has been assigned.
    // Used to add active to label to avoid overlap when pre-populated input
    private hasSheetName(): boolean {
        return (this.currentSheetName && this.currentSheetName.length > 0);
    }

    // Create array os select options of all properties in the data objects
    private populateColumnNames(): void {
        if (this.data instanceof Array && this.data.length > 0) {
            for (let key in this.data[0]) {
                if (this.data[0].hasOwnProperty(key)) {
                    let columnCheckbx: ImportColumnCheckboxModel = {
                        columnKey: key,
                        includeColumn: true
                    }
                    this.coloumnCheckBoxes.push(columnCheckbx);
                }
            }
        }
    }

    // Check if entered sheet name is valid
    private sheetNameValid(): boolean {
        let regEx = new RegExp(/^(\w+\s?)*\w$/);
        return (regEx.test(this.currentSheetName) || this.replyToCaller);
    }

    // Check if at least one column has been selected
    private columnSelected(): boolean {
        return (this.coloumnCheckBoxes.some(cbx => cbx.includeColumn === true));
    }

    // Send data, selected properties and sheet name to sheet service to be added to workbook
    private userSelection(): void {
        // If not marked to reply to sender, add sheet directly to workbook
        if (!this.replyToCaller) {
            // Use selection to add sheet directly to work using different function
            this._sheetService.addSheet(this.data, this.coloumnCheckBoxes, this.currentSheetName)
                .then(() => {});
        }
        this.waitingForSelection = false;
        this.close();
    }

    // Close this components modal and clear data
    public close(): void {
        if (this.replyToCaller) {
            this.reply();
        }
        this.currentSheetName = '';
        this.data = null;
        this.coloumnCheckBoxes = [];
        this.rememberColumns = false;
        this.waitingForSelection = false;
        this.replyToCaller = false;
        $('#sheet-export-import-modal').modal('close');
    }

    // Reply to caller
    private reply(): void {
        // Reply to caller, call sheet function to broadcast selection
        this._sheetService.replySelectionToCaller(this.rememberColumns, this.coloumnCheckBoxes, this.waitingForSelection, this.callerName);
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/sheet-export-import/sheet-export-import.component.ts